// src/components/RightPanel/ContentSwitcher.js
import React from 'react';
import useContentViewStore from '../../contexts/useContentViewStore';

const ContentSwitcher = () => {
  const { currentView, setView } = useContentViewStore();

  return (
    <div className="flex space-x-2 p-1 bg-gray-100">
      <button
        onClick={() => setView('Explore')}
        className={`text-xs px-4 py-1 rounded ${currentView === 'Explore' ? 'bg-[var(--brandprimary)] text-white' : 'bg-gray-200 text-gray-700'}`}
      >
        Explore
      </button>
      <button
        onClick={() => setView('Map')}
        className={`text-xs px-4 py-1 rounded ${currentView === 'Map' ? 'bg-[var(--brandprimary)] text-white' : 'bg-gray-200 text-gray-700'}`}
      >
        Map
      </button>
    </div>
  );
};

export default ContentSwitcher;
